module.exports = __webpack_public_path__ + "static/media/referfriend.ab87fe44.png";